module.exports = __webpack_public_path__ + "static/media/yrose.69f7330d.png";